import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/images/ig.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/tg.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/vk.svg");
;
import(/* webpackMode: "eager" */ "/app/src/components/EventDetail/EventDetail.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/EventDetailGallery/EventDetailGallery.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/EventDetailTickets/EventDetailTickets.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ReviewList/ReviewList.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ReviewText/ReviewText.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/ReviewContent/ReviewContent.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/EventDetailReview/EventDetailReview.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ScheduleList/ScheduleList.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/loaders/image-loader.js");
